module.exports = __webpack_public_path__ + "static/media/logo3.711e9737.svg";